import { render, staticRenderFns } from "./typeTestProcessList.vue?vue&type=template&id=99ad9ac8&scoped=true"
import script from "./typeTestProcessList.vue?vue&type=script&lang=js"
export * from "./typeTestProcessList.vue?vue&type=script&lang=js"
import style0 from "./typeTestProcessList.vue?vue&type=style&index=0&id=99ad9ac8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ad9ac8",
  null
  
)

export default component.exports